import type { CmpHider } from './types';

export const vanillaCookieConsent: CmpHider = {
  id: 'vanilla-cookieconsent',
  label: 'Cookie Consent (Orestbida)',
  css: `
      /* Cookie Consent by Orest Bida (vanilla-cookieconsent v3, the #cc-main
         library — distinct from the Insites ".cc-window" lib handled above): the
         whole consent UI mounts inside a single root container "#cc-main"
         (position:fixed, z-index 2147483647) appended to <body>. That root holds
         the first-visit consent banner (".cm-wrapper" / ".cm"), the preferences
         modal (".pm-wrapper" / ".pm"), and both dimming backdrops — the banner
         dimmer is a ".cm-wrapper:before" pseudo-element and the preferences dimmer
         is "#cc-main .pm-overlay", both children of "#cc-main" — so hiding
         "#cc-main" removes the banner, the modal, and the faded background in one
         go. We also list ".pm-overlay" plus the legacy v2 root "#cc--main" /
         ".cc_div" defensively in case a build mounts them outside the root.
         vanilla-cookieconsent v3 locks page scroll by adding the
         "disable--interaction show--consent" classes to <html>, whose own rule
         "html.disable--interaction.show--consent, ...body { overflow: hidden
         !important; height: auto !important }" is injected at runtime AFTER this
         style — matching its specificity plus !important loses on source order, so
         we append a "[class]" attribute selector (one extra attribute, present
         since the lock classes live on the class attribute) to out-specify it on
         both <html> and <body>. No backticks anywhere in this block — it is a JS
         template literal. */
      #cc-main,
      #cc-main .pm-overlay,
      #cc--main,
      .cc_div { display: none !important; }
      html.disable--interaction.show--consent[class],
      html.disable--interaction.show--consent[class] body {
        overflow: visible !important;
        height: auto !important;
      }
  `,
};
